import React from 'react';
import Navbar from '../components/navbar';
import MapaCapis from '../components2/mapaCapis';

function UbicacionCapis () {
    return (
        <MapaCapis />
    )
}

export default UbicacionCapis;